export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8099.97cdcd6c.jpg";